import React, { Component } from 'react';
import { isEmpty } from 'lodash';

const Branch = (ComponentData, NoData) => {
  class HOC extends Component {
    render() {
      const { pressureData, isLoading } = this.props;

      if (!isLoading && isEmpty(pressureData.data)) {
        return <NoData />;
      }

      return <ComponentData {...this.props} />;
    }
  }

  return HOC;
};

export default Branch;



// WEBPACK FOOTER //
// ./resources/assets/js/components/PressureSimulate/Branch.js